import { H3 } from "@/components/ui/typography";
import { useAuth } from "../auth/useAuth";
import { RFSStatistics } from "./statistic/RFSStatistics";

export default function TabDashboardRFS() {
  const auth = useAuth();
  const user = auth.getUser();
  if (!user) {
    console.error("User is not found.");
    return null;
  }

  return (
    <div className="flex flex-col gap-y-8">
      <H3>Dashboard Linknet - Interval NRO</H3>
      <RFSStatistics />
    </div>
  );
}
